/**
 * Public catalog URL for a book (prefers SEO slug when present).
 */
export function bookPublicPath(book: { slug?: string | null; id: string }): string {
  return `/books/${book.slug ?? book.id}`
}
